import { IconPlus } from '@tabler/icons-react';
import type React from 'react';
import { useState } from 'react';
import { PartyFileFormatsPanel } from '@/components/file-formats/party-file-formats-panel';
import { Button } from './ui/button';

interface FileFormatsSectionProps {
  partyId: string;
  partyName?: string;
  partyCode?: string;
}

export const FileFormatsSection: React.FC<FileFormatsSectionProps> = ({
  partyId,
  partyName,
  partyCode,
}) => {
  const [addOpen, setAddOpen] = useState(false);

  return (
    <div className="px-4 lg:px-6">
      <div className="rounded-md border">
        <div className="flex items-start justify-between p-5 border-b">
          <div>
            <p className="font-medium text-sm">File Formats</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Payment file parsing and generation formats scoped to this provider.
            </p>
          </div>
          <Button variant="default" size="sm" className="gap-1.5" onClick={() => setAddOpen(true)}>
            <IconPlus size={14} />
            Add File Format
          </Button>
        </div>

        <div className="p-4">
          <PartyFileFormatsPanel
            partyId={partyId}
            scope="provider"
            partyName={partyName}
            partyCode={partyCode}
            hideHeaderAdd
            addOpen={addOpen}
            onAddOpenChange={setAddOpen}
          />
        </div>
      </div>
    </div>
  );
};
